import React from "react";
import { Result, Button } from "antd";
import { useNavigate } from "react-router-dom";
import { all_routes } from "../../routes/all_routes";

const Unauthorized = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <Result
        status="403"
        title="403"
        subTitle="Sorry, you are not authorized to access this page."
        extra={
          <Button
            type="primary"
            onClick={() => navigate(all_routes.userDashboard)}
          >
            Back to Dashboard
          </Button>
        }
      />
    </div>
  );
};

export default Unauthorized;
